import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import Media from "../../core/media";
var ContentCardMedia = createComponent({
  displayName: 'ContentCardMedia',
  propTypes: {},
  defaultProps: {},
  render: function render(p) {
    var _children = _.isArray(p.children) ? p.children : [p.children];

    return !!_children ? /*#__PURE__*/React.createElement("div", {
      className: "content-card-media"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-card-media__inner"
    }, _mapInstanceProperty(_children).call(_children, function (child, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "content-card-media__thumbnail"
      }, /*#__PURE__*/React.isValidElement(child) ? child : /*#__PURE__*/React.createElement(Media, {
        reference: child
      }));
    }, this))) : null;
  }
});
export default ContentCardMedia;
//# sourceMappingURL=content-card-media.js.map